<template>
	<BaseCard
		:is-editable="!isProcessFinished && isEditAllowed && editRoute !== undefined"
		:title="title"
		@clickEdit="$router.push({ name: editRoute, params: { id: $route.params.processId || $route.params.id } })"
		:is-toggle-open="isToggleOpen"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
	>
		<div v-if="person">
			<BaseCardRow :value="person.organisation" v-if="person.organisation" :missing-label="$t('company')"></BaseCardRow>
			<BaseCardRow
				:value="person.company.name"
				v-else-if="person.company && person.company.companyable.self_employed === 0"
				:missing-label="$t('company')"
			></BaseCardRow>
			<BaseCardRow :value="name" :missing-label="$t('name')"></BaseCardRow>
			<BaseCardRow v-if="street != null" :value="street" :missing-label="$t('street')" />
			<BaseCardRow v-else :value="person.poBox" :missing-label="$t('po_box')" />
			<BaseCardRow :value="city" :missing-label="$t('city')"></BaseCardRow>
			<BaseCardRow :value="phone" :missing-label="$t('phone')" class="mt-6"></BaseCardRow>
			<BaseCardRow :value="person.email" :missing-label="$t('e_mail')"></BaseCardRow>
		</div>

		<div class="font-bold" v-else>{{ title }} {{ $t('not_stored') }}</div>
	</BaseCard>
</template>
<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';
import { concatArray, getPersonTitlesOption } from '@/plugins/Utils';

export default {
	name: 'PersonCard',
	components: { BaseCard, BaseCardRow },
	props: {
		person: { required: true },
		isProcessFinished: {},
		isEditAllowed: { type: Boolean, default: true },
		title: { type: String, required: true },
		editRoute: { type: String },
		isToggleOpen: { type: Boolean, default: true },
	},
	computed: {
		phone() {
			return this.person?.cellNumber || this.person?.phoneNumber;
		},
		street: function() {
			if (this.person.street === null) {
				return null;
			}
			return concatArray([this.person.street, this.person.houseNumber]);
		},
		name: function() {
			if (this.person.damageAssessor === null && !this.person.companyable.is_system_partner) return this.person.name;
			if (this.person.gender === 'company') {
				return concatArray(['Firma', this.person.company.name]);
			}
			return concatArray([this.person.title, this.person.firstName, this.person.lastName]);
		},
		city() {
			return concatArray([this.person.city?.zipCode, this.person.city?.name]);
		},
	},
	methods: {
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
	},
};
</script>
